<template>
    <div
        class="app-sidebar-dock"
        @mouseenter="onSidebarMouseEnter"
        @mouseleave="onSidebarMouseLeave"
    >
    <div class="sidebar primary" id="dvSidebarPrimary">

        <!--Header Section-->

        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <a class="btn btn-block btn-header btn-header-icon" id="sidebarToggle" @click="toggleSidebar">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="14" viewBox="0 0 21 14" fill="none" aria-hidden="true">
                            <path d="M1.47656 7H19.8392M1.47656 13H19.8392M1.47656 1H19.8392" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <router-link
                        class="btn btn-block btn-header btn-header-icon"
                        to="/tela-principal"
                        title="Início"
                        active-class="sidebar-nav-active"
                        @click="collapseSecondaryPanel"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 22V12h6v10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <router-link
                        class="btn btn-block btn-header btn-header-icon"
                        to="/agentes"
                        title="Agentes"
                        active-class="sidebar-nav-active"
                        @click="collapseSecondaryPanel"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <rect x="5" y="7" width="14" height="12" rx="2" stroke="currentColor" stroke-width="2" />
                            <path d="M9 7V5a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            <circle cx="9.5" cy="12.5" r="1.25" fill="currentColor" />
                            <circle cx="14.5" cy="12.5" r="1.25" fill="currentColor" />
                            <path d="M9 16.5h6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <router-link
                        class="btn btn-block btn-header btn-header-icon"
                        to="/configuracao-equipe"
                        title="Equipe"
                        active-class="sidebar-nav-active"
                        @click="collapseSecondaryPanel"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <circle cx="12" cy="5" r="2.5" fill="none" stroke="currentColor" stroke-width="2" />
                            <path d="M12 7.5V11" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" />
                            <path d="M12 11H6.5M12 11H17.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" />
                            <path d="M6.5 11V15.5M17.5 11V15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none" />
                            <circle cx="6.5" cy="18" r="2.5" fill="none" stroke="currentColor" stroke-width="2" />
                            <circle cx="17.5" cy="18" r="2.5" fill="none" stroke="currentColor" stroke-width="2" />
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <router-link
                        class="btn btn-block btn-header btn-header-icon"
                        to="/configuracao-empresa"
                        title="Empresa"
                        active-class="sidebar-nav-active"
                        @click="collapseSecondaryPanel"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M3 21h18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M5 21V10l7-3 7 3v11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 21v-7h6v7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M9 10h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <router-link
                        class="btn btn-block btn-header btn-header-icon"
                        to="/configuracoes"
                        title="Conta"
                        active-class="sidebar-nav-active"
                        @click="collapseSecondaryPanel"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="sidebar-header">
            <div class="header-button">
                <div class="button">
                    <router-link
                        class="btn btn-block btn-header btn-header-icon"
                        to="/modulos"
                        title="Marketplace"
                        active-class="sidebar-nav-active"
                        @click="collapseSecondaryPanel"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="2" />
                            <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="2" />
                            <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="2" />
                            <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="2" />
                        </svg>
                    </router-link>
                </div>
            </div>
        </div>


        <!--Content Section-->

        <div class="sidebar-content">
            <div class="content-button">
                <div class="button">
                    <router-link
                        class="btn btn-block btn-content btn-content-plus"
                        to="/mais"
                        title="Muito mais em breve"
                        active-class="sidebar-nav-active-content"
                        @click="collapseSecondaryPanel"
                    >
                        <span class="icon" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="38" viewBox="0 0 35 38" fill="none">
                                <path d="M16.8021 25.8132V11H19.3158V25.8132H16.8021ZM10.6523 19.6635V17.1497H25.4656V19.6635H10.6523Z" fill="currentColor" />
                            </svg>
                        </span>
                    </router-link>
                </div>
            </div>
        </div>
        
    </div>

    <!--Sidebar - Secondary-->

    <div class="section sidebar secondary" :class="{ 'active': !showSecondaySideBar }">

        <!--Header Section-->

        <div class="sidebar-header">
            <router-link
                to="/tela-principal"
                class="sidebar-secondary-brand"
                title="Início Escolar.Ai"
            >
                <img src="/assets/images/logo/logo-escolarai-a.svg" class="logo-escolarai-a" alt="Escolar.Ai" />
            </router-link>
        </div>

        <!--Content Section-->

        <div class="sidebar-content">
            <div class="content-accordion">
                <div class="accordion" id="accordionSidebarSecondaryContent">
                    <div class="accordion-item">
                        <div class="accordion-header" id="heading-1-SidebarSecondaryContent">
                            <div class="header-link">
                                <div class="link">
                                    <a class="link-header" data-bs-toggle="collapse" data-bs-target="#collapse-1-SidebarSecondaryContent" aria-expanded="true" aria-controls="collapse-1-SidebarSecondaryContent">
                                        <span class="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 4V8L10.6667 9.33333" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                                <circle cx="8" cy="8" r="6" stroke="currentColor" stroke-width="1.33333"/>
                                            </svg>
                                        </span>
                                        <span class="text">
                                            Histórico
                                        </span>
                                    </a>
                                </div>
                            </div>
                     
                        </div>
                        <div id="collapse-1-SidebarSecondaryContent" class="accordion-collapse collapse show" aria-labelledby="heading-1-SidebarSecondaryContent" data-bs-parent="#accordionSidebarSecondaryContent">
                            <div class="accordion-body">
                                <div class="body-link">
                                    <div v-if="loading" class="loader-container">
                                        <div class="loader"></div>
                                    </div>
                                    <div v-else class="link" v-for="order in ordersHistoryLocal.slice(0, 5)" :key="order.id">
                                        <a class="link-body"  @click="goToChat(order)">
                                            {{ order.title }}
                                        </a>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="accordion-item">
                        <div class="accordion-header" id="heading-2-SidebarSecondaryContent">
                            <div class="header-link">
                                <div class="link">
                                    <a class="link-header" data-bs-toggle="collapse" data-bs-target="#collapse-2-SidebarSecondaryContent" aria-expanded="true" aria-controls="collapse-2-SidebarSecondaryContent">
                                        <span class="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M7.99999 1.33334L10.0607 5.50668L14.6667 6.18001L11.3333 9.42668L12.1213 14.0133L7.99999 11.8467L3.87866 14.0133L4.66666 9.42668L1.33333 6.18001L5.93933 5.50668L7.99999 1.33334Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </span>
                                        <span class="text">
                                            Favoritos
                                        </span>
                                    </a>
                                </div>
                            </div>
                     
                        </div>
                        <div id="collapse-2-SidebarSecondaryContent" class="accordion-collapse collapse" aria-labelledby="heading-2-SidebarSecondaryContent" data-bs-parent="#accordionSidebarSecondaryContent">
                            <div class="accordion-body">
                                <div class="body-link">
                                    <div v-if="loading" class="loader-container">
                                        <div class="loader"></div>
                                    </div>
                                    <div v-else class="link" v-for="order in favoriteOrders.slice(0, 10)" :key="order.id">
                                        <a class="link-body"  @click="goToChat(order.id)">
                                            {{ order.title }}
                                        </a>
                                    </div>                                    
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="accordion-item" v-for="(orderCrew, index) in ordersCrews" :key="orderCrew.id">
                        <div class="accordion-header" :id="'heading-crew-' + index">
                            <div class="header-link">
                                <div class="link">
                                    <a class="link-header collapsed" href="javascript:void(0);" data-bs-toggle="collapse" :data-bs-target="'#collapse-crew-' + index" aria-expanded="false" :aria-controls="'collapse-crew-' + index">
                                        <span class="icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <circle cx="8.00016" cy="8.00016" r="6" stroke="currentColor" stroke-width="1.33333" />
                                                <path d="M10.0002 8.00016C10.0002 9.77801 9.7107 11.3569 9.2668 12.4666C9.0441 13.0233 8.79561 13.4291 8.55378 13.6849C8.31328 13.9392 8.12597 14.0002 8.00016 14.0002C7.87435 14.0002 7.68704 13.9392 7.44655 13.6849C7.20472 13.4291 6.95622 13.0233 6.73353 12.4666C6.28962 11.3569 6.00016 9.77801 6.00016 8.00016C6.00016 6.22231 6.28962 4.64347 6.73353 3.53371C6.95622 2.97698 7.20472 2.57118 7.44655 2.31547C7.68704 2.06116 7.87435 2.00016 8.00016 2.00016C8.12597 2.00016 8.31328 2.06116 8.55378 2.31547C8.79561 2.57118 9.0441 2.97698 9.2668 3.53371C9.7107 4.64347 10.0002 6.22231 10.0002 8.00016Z" stroke="currentColor" stroke-width="1.33333" />
                                                <path d="M2 8H14" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" />
                                            </svg>
                                        </span>
                                        <span class="text">
                                            {{ orderCrew.name.length > 18 ? orderCrew.name.substring(0,18) + '...' : orderCrew.name }}
                                        </span>
                                    </a>
                                </div>
                            </div>
                           
                        </div>
                        <div :id="'collapse-crew-' + index" class="accordion-collapse collapse" :aria-labelledby="'heading-crew-' + index" data-bs-parent="#accordionSidebarSecondaryContent">
                            <div class="accordion-body">
                                <div class="body-link">
                                    <div v-if="loading" class="loader-container">
                                        <div class="loader"></div>
                                    </div>
                                    <div v-else class="link" v-for="orderCrewOrder in orderCrew.orders.slice(0, 5)" :key="orderCrewOrder.id" >
                                        <a class="link-body"  @click="goToChat(orderCrewOrder.id)">
                                            {{ orderCrewOrder.name }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="version">
                <p>{{ appVersionLabel }}</p>
                <p>@Copyright Escolar.Ai</p>
            </div>
        </div>

    </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toast } from 'vue3-toastify';

import order from '@/utils/order';
import { APP_VERSION_LABEL } from '@/constants/release';

export default {
    name: 'PrimarySidebar',
    data() {
        return {
            appVersionLabel: APP_VERSION_LABEL,
            ordersHistoryLocal: [],
            ordersCrews: [],
            /* true = painel secundário recolhido (só a barra de ícones visível) */
            showSecondaySideBar: true,
            favoriteOrders: [],
            loading: false,
            sidebarHover: false,
            sidebarTimeout: null
        };
    },
    computed: {
        ...mapState(['token', 'userInfoData', 'crewsList', 'account', 'ordersHistory', 'orderByCrewsHistory', 'favoriteOrdersHistory'])
    },
    methods: {
        ...mapActions(['storeCurrentCrewHistory', 'storeOrdersHistory', 'storeOrderByCrewsHistory', 'storeFavoriteOrdersHistory']),
        toggleSidebar(){
            this.showSecondaySideBar = !this.showSecondaySideBar;
        },
        notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: this.isMobile ? 'top-center' : 'top-right',
                theme: "light", 
                type: type,
                dangerouslyHTMLString: true
            });
        },
        collapseSecondaryPanel() {
            this.showSecondaySideBar = true;
        },
        async getListOrders() {
            try {
                this.loading = true;
                const response = await order.getListOrders(this.token);
                this.storeOrdersHistory({ ordersHistory: response });
                this.ordersHistoryLocal = response;
            } catch (error) {
                console.error('Erro ao buscar pedidos:', error);
            } finally {
                this.loading = false;
            }
        },
        async getOrderByCrews() {
            try {
                this.loading = true;
                const response = await order.getOrderByCrews(this.token);
                this.storeOrderByCrewsHistory({ orderByCrewsHistory: response });
                this.ordersCrews = response;
            } catch (error) {
                console.error('Erro ao buscar pedidos:', error);
            } finally {
                this.loading = false;
            }
        },
        async getFavoriteOrders() {
            try {
                this.loading = true;
                const response = await order.getFavoriteOrders(this.token);
                this.storeFavoriteOrdersHistory({ favoriteOrdersHistory: response });
                this.favoriteOrders = response;
            } catch (error) {
                console.error('Erro ao buscar pedidos favoritados:', error);
            } finally {
                this.loading = false;
            }
        },
        goToChat(crew){
            this.storeCurrentCrewHistory({ currentCrewHistory: crew });
            this.$router.push(`/conversa-em-andamento/${crew.id}`);
        },
        onSidebarMouseEnter() {
            this.sidebarHover = true;
            if (this.sidebarTimeout) {
                clearTimeout(this.sidebarTimeout);
                this.sidebarTimeout = null;
            }
        },
        onSidebarMouseLeave() {
            this.sidebarHover = false;
            if (this.sidebarTimeout) {
                clearTimeout(this.sidebarTimeout);
                this.sidebarTimeout = null;
            }
            // Aguarda 5 segundos e só oculta se o mouse não voltou para a sidebar
            this.sidebarTimeout = setTimeout(() => {
                if (!this.sidebarHover && !this.showSecondaySideBar) {
                    this.toggleSidebar();
                }
            }, 5000);
        }
    },
    mounted() {
        if (!this.token) {
            return;
        }
        /* Antes: !this.ordersHistory com [] no Vuex é sempre false (array vazio é truthy),
           logo fora da tela principal caía no else com loading=true e nunca repovoava o histórico. */
        const ordersCached = Array.isArray(this.ordersHistory) && this.ordersHistory.length > 0;
        const crewsCached = Array.isArray(this.orderByCrewsHistory) && this.orderByCrewsHistory.length > 0;

        if (!ordersCached || !crewsCached) {
            this.getListOrders();
            this.getOrderByCrews();
            this.getFavoriteOrders();
        } else {
            this.ordersHistoryLocal = Array.isArray(this.ordersHistory) ? this.ordersHistory : [];
            this.ordersCrews = Array.isArray(this.orderByCrewsHistory) ? this.orderByCrewsHistory : [];
            this.favoriteOrders = Array.isArray(this.favoriteOrdersHistory) ? this.favoriteOrdersHistory : [];
        }
    }
};
</script>

<style lang="scss" scoped>
.app-sidebar-dock {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    flex-shrink: 0;
    height: 100%;
    position: relative;
    z-index: 200;
}
/* Fechada: fora do fluxo flex = zero largura na dock; não fica “faixa” visível */
.sidebar.secondary {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 70px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 270px;
    min-width: 270px;
    max-width: 270px;
    padding: 0;
    margin: 0;
    overflow: hidden;
    background-color: #212226;
    transform: translateX(-100%);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 100;
    transition: transform 0.35s ease, opacity 0.25s ease, visibility 0.25s,
        padding 0.25s ease;
}

.sidebar.secondary.active {
    position: relative;
    left: auto;
    transform: translateX(0);
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    padding: 1.5rem !important;
    overflow: hidden;
}

@media (max-width: 991.98px) {
    .sidebar.secondary {
        left: 75px;
    }
    .sidebar.secondary.active {
        left: auto;
    }
}

/* Mobile: mesmo padrão do css-master (painel fixo, não reserva espaço na dock) */
@media (max-width: 767.98px) {
    .sidebar.secondary {
        position: fixed;
        top: 58px;
        left: -270px;
        height: calc(100vh - 58px) !important;
        transform: none;
    }
    .sidebar.secondary.active {
        position: fixed;
        left: 0;
        top: 58px;
        transform: none;
    }
}

.sidebar.secondary .sidebar-content {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
}
.sidebar.secondary .content-accordion {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

/* Barra primária: traços/fill usam currentColor a partir destes tons */
.sidebar.primary .btn-header-icon {
    color: #cacaca;
    text-decoration: none;
    transition: color 0.15s ease, background-color 0.15s ease;
}
.sidebar.primary .btn-header-icon:hover {
    color: #e8e8ea;
}
.sidebar.primary a.sidebar-nav-active {
    color: #ceff1f;
    background: rgba(206, 255, 31, 0.14);
    border-radius: 10px;
}
.sidebar.primary a.sidebar-nav-active:hover {
    color: #dff565;
}

.sidebar.primary .btn-content-plus {
    color: #29bbff;
    text-decoration: none;
    transition: color 0.15s ease, box-shadow 0.15s ease;
}
.sidebar.primary .btn-content-plus:hover {
    color: #5bccff;
}
.sidebar.primary a.sidebar-nav-active-content {
    color: #ceff1f;
    box-shadow: 0 0 0 2px rgba(206, 255, 31, 0.45);
    border-radius: 100%;
}
.sidebar.primary a.sidebar-nav-active-content:hover {
    color: #dff565;
}

/* Accordion da sidebar secundária: ícones alinhados ao tema */
.sidebar.secondary .link-header .icon {
    color: #ceff1f;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.sidebar-secondary-brand {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 0.35rem;
    text-decoration: none;
}
.version {
    color: white;
    position: relative;
    flex-shrink: 0;
    margin-top: auto;
    padding-top: 1rem;
    text-align: center;
    width: 100%;
}
.version p {
    margin: 0;
    color: gray;
    font-size: 11px;
}
a.link-body {
    text-align: left;
}
.logo-escolarai-a {
    width: 100px!important;
}
.body-link > .link a.link-body {
    cursor: pointer;
}
.accordion-header a.link-header {
    cursor: pointer;
}
</style>
